function setupWebViewJavascriptBridge(callback) {
    if (window.WebViewJavascriptBridge) { return callback(WebViewJavascriptBridge); }
    if (window.WVJBCallbacks) { return window.WVJBCallbacks.push(callback); }
    window.WVJBCallbacks = [callback];
    var WVJBIframe = document.createElement('iframe');
    WVJBIframe.style.display = 'none';
    WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__';
    document.documentElement.appendChild(WVJBIframe);
    setTimeout(function() { document.documentElement.removeChild(WVJBIframe) }, 0)
  }
  
  setupWebViewJavascriptBridge(function(bridge) {
    bridge.callHandler('nativeAlert', 'Hello world');
    bridge.registerHandler('echoHandler', function(data, responseCallback) {
      responseCallback(data)
    })
    bridge.registerHandler('jsRcvResponseTest', function(data, responseCallback) {
      bridge.callHandler('objcEchoToJs', { foo:'bar' }, function(response) {
        if (response && response.foo == 'bar') {
          responseCallback("Response from JS")
        } else {
          responseCallback("Failed ")
        }
      })
    })
  })
  
  const wView = {
    pushTo: function(href){
      var bridge = window.WebViewJavascriptBridge;
      if(window.WebViewJavascriptBridge){
        bridge.callHandler('pushTo',href)
      }else{
        window.location.href = href
      }
    },
    openBrowser: function(href){
      var bridge = window.WebViewJavascriptBridge;
      if(window.WebViewJavascriptBridge){
        bridge.callHandler('openBrowser',href);
      }
    },
    updateUser: function(){
      var bridge = window.WebViewJavascriptBridge;
      if(window.WebViewJavascriptBridge){
        bridge.callHandler('updateUser');
      }
    },
    payOrder: function (payChannel, orderNo, callback ) {
      var bridge = window.WebViewJavascriptBridge
      if(window.WebViewJavascriptBridge) {
        bridge.callHandler ('payOrder', { 'payChannel': payChannel, 'orderNo': orderNo}, function (response) {
          callback(response)
        })
      }
    },
    shareFree: function(shareArguments,callback){
      var bridge = window.WebViewJavascriptBridge;
      if(window.WebViewJavascriptBridge){
        bridge.callHandler('share',shareArguments,function(response){
          callback(response);
        });
      }
    },
    share: function(shareArguments){
      var bridge = window.WebViewJavascriptBridge;
      var newShareUrl = 'https://quanzi.qufaya.com/challenge/share?type=1&token=' + window.$config.shareToken
      // var newShareArguments = {
      //   'title': window.$config.name+'用圈子账本记账，赚了'+window.$config.totalBonus+'元，快和TA一起参加',
      //   'url': newShareUrl,
      //   'imageUrl': 'https://static.xixitime.com/challenge/images/shareicon.png',
      //   'shareType': 6
      // }
      // if(window.WebViewJavascriptBridge){
      //   if(window.$config.totalBonus != 0 ){
      //     bridge.callHandler('share',newShareArguments,function(response){
      //       if(response.result){
      //         Vue.http.post('/challenge/statistics?app='+window.$config.appArguments, {'event': 'EXPENSE_CHALLENGE_SHARE_'+response.shareType+'_'+window.$config.shareToken}).then(function(response) {
      //           if(window.$config.name == '喵~'){
      //             alert('统计'+window.$config.name)
      //           }
      //         }, function(response) {
      //         });
      //       }else{
      //         alert('分享失败');
      //       }
      //     });
      //   }else{
          bridge.callHandler('share',shareArguments,function(response){
            if(response.result){
              // Vue.http.post('/challenge/statistics?app='+window.$config.appArguments, {'event': 'EXPENSE_CHALLENGE_SHARE_'+response.shareType+'_'+window.$config.shareToken}).then(function(response) {
              // }, function(response) {
              // });
            }else{
              // alert('分享失败');
            }
          });
    },
    notificationEable: function(callback){
      var bridge = window.WebViewJavascriptBridge;
      if(window.WebViewJavascriptBridge){
        bridge.callHandler('notificationEable',{},function(response){
          callback(response);
        });
      }
    },
    openNotification: function(){
      var bridge = window.WebViewJavascriptBridge;
      if(window.WebViewJavascriptBridge){
        bridge.callHandler('openNotification');
      }
    }
  }
  
  export default wView
  